import { render, staticRenderFns } from "./createCard.vue?vue&type=template&id=184c6342&scoped=true&"
import script from "./createCard.vue?vue&type=script&lang=js&"
export * from "./createCard.vue?vue&type=script&lang=js&"
import style0 from "./createCard.vue?vue&type=style&index=0&id=184c6342&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184c6342",
  null
  
)

export default component.exports